/**
 * Расписание отправки времени на странице.
 *
 * Частим в начале и разряжаем дальше: первые секунды отделяют случайный заход
 * от осмысленного, а после двух минут такая точность уже не нужна и только
 * жжёт сеть.
 *
 * Отсчёт ведётся от открытия страницы или от возврата из фона — после
 * сворачивания расписание начинается заново.
 */
export const nextTimeReportDelay = (elapsedMs: number): number => {
  if (elapsedMs < 15_000) return 5_000
  if (elapsedMs < 60_000) return 15_000
  if (elapsedMs < 120_000) return 30_000
  return 60_000
}

/**
 * Больше пяти минут одной отправкой сервер не принимает. Такой отрезок может
 * получиться, только если что-то пошло не так со счётчиком, поэтому режем.
 */
export const MAX_DURATION_MS = 5 * 60_000

export const clampDuration = (durationMs: number): number =>
  Math.min(Math.max(Math.round(durationMs), 0), MAX_DURATION_MS)
